import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { WorkflowGraphVertexInteractionPoint } from './workflow-graph-vertex-interaction-point';
import {
  WorkflowGraphDispatcherAction,
  WorkflowGraphDispatcherActionType,
  WorkflowGraphDispatcherService
} from '../../workflow-graph-dispatcher.service';
import { WorkflowGraphVertexOutletPointComponent } from './index';
import { DataType } from 'buzzyears.core';
import { WorkflowGraphService } from '../../workflow-graph.service';
import { WorkflowEdge } from 'component.workflow.core';

@Component({
  selector: 'g[wf-graph-vertex-inlet-point]',
  template: `

    <svg:text class="io-type" [ngClass]="{'activated-io-type': activate}" [attr.x]="textX" [attr.y]="textY"
              font-size="14"
              [attr.text-anchor]="anchor">
      <svg:tspan font-weight="bold">{{ name }}</svg:tspan>
      <svg:tspan>:</svg:tspan>
      <svg:tspan>{{ typeText }}</svg:tspan>
    </svg:text>

    <svg:circle *ngIf="initialized" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)"
                xmlns:svg="http://www.w3.org/1999/html" [attr.cx]="specification.at.x"
                [attr.cy]="specification.at.y" fill="#fff" stroke="#00F" stroke-width="1"
                [class.highlighted-point]="highlight"
                [attr.r]="radius"/>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkflowGraphVertexInletPointComponent extends WorkflowGraphVertexInteractionPoint implements OnInit, OnDestroy {

  activate = false;
  highlight = false;

  constructor(dispatcherService: WorkflowGraphDispatcherService, graphService: WorkflowGraphService, protected cdr: ChangeDetectorRef) {
    super(dispatcherService, graphService);
  }

  onDispatcherEvent(action: WorkflowGraphDispatcherAction) {
    switch (action.type) {

      case WorkflowGraphDispatcherActionType.ConnectionDrawInitiated:
        this.activateIfNeeded(action.originator);
        break;

      case WorkflowGraphDispatcherActionType.ConnectionDrawTerminated:
        this.activate = false;
        this.highlight = false;
        this.cdr.markForCheck();
        break;
    }
  }

  onMouseEnter(event: MouseEvent) {
    if (!this.activate) {
      return;
    }

    this.dispatcherService.dispatchAction(WorkflowGraphDispatcherActionType.ConnectionDrawReceiverActivated, this);
    this.highlight = true;
    this.cdr.markForCheck();
  }

  onMouseLeave(event: MouseEvent) {
    if (!this.activate) {
      return;
    }

    this.dispatcherService.dispatchAction(WorkflowGraphDispatcherActionType.ConnectionDrawReceiverDeactivated, this);
    this.highlight = false;
    this.cdr.markForCheck();
  }

  activateIfNeeded(outletPoint: WorkflowGraphVertexOutletPointComponent) {

    if (outletPoint.vertex === this.vertex) {
      return;
    }

    if (outletPoint.point.dataType === DataType.Mixed ||
      this.point.dataType === DataType.Mixed ||
      outletPoint.point.dataType === this.point.dataType) {

      const inlet = this.point.named ? this.point.key : undefined;

      if (this.point.maximum) {
        // There is an upper limit for the point so lets check if its met
        let count = 0;
        this.vertex.incoming.forEach((e: WorkflowEdge) => {
          if (e.inlet === inlet) {
            count++;
          }
        });

        if (count >= this.point.maximum) {
          return;
        }
      }

      let linkExists = false;
      // check if a connection already exists
      this.vertex.incoming.forEach((e: WorkflowEdge) => {

        if (e.fromVertex === outletPoint.vertex) {
          // If a link exists between this and the outlet node.

          if (e.fromOutlet.named && outletPoint.point.key !== e.fromOutlet.key) {
            // do not count linked names
            return;
          }

          if (e.inlet === inlet) {
            linkExists = true;
          }
        }
      });

      if (linkExists) {
        return;
      }

      this.activate = true;
      this.cdr.markForCheck();
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  get direction(): string {
    return 'in';
  }
}



// WEBPACK FOOTER //
// ./src/library/graph/vertex/interaction-point/workflow-graph-vertex-inlet-point.component.ts